<template>
  <el-main >
     <!-- <el-main style="margin-top: -2%"> -->
      <el-form  :model="processInstanceInfo" ref="processInstanceForm" size="mini" label-width="120px">
          <el-row v-if="templateInfo.nameGenerationMode==='single'">
              <el-col :span="22">
                  <el-form-item label="流程实例名称"
                      prop="instanceName"
                      :rules="[
                          { required: true, message: '请输入流程实例名称', trigger: 'blur' },
                      ]" >
                      <el-input placeholder="请输入内容" v-model="processInstanceInfo.instanceName"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="2">
                  <el-tooltip content="重新获取一个新的流水号" placement="top">
                      <el-button type="primary" class="resetProcessInstance" size="mini" :loading="reSetLoading" icon="el-icon-refresh-right" title="刷新" style="margin-left: 5px;" circle @click="reSetSerialNumber()"></el-button>
                  </el-tooltip>
              </el-col>
          </el-row>
          <el-row v-else >
              <el-form-item label="流程实例名称"
                prop="instanceName"
                :rules="[
                  { required: true, message: '请输入流程实例名称', trigger: 'blur' },
                ]"
              >
                <el-input placeholder="请输入内容" v-model="processInstanceInfo.instanceName"></el-input>
              </el-form-item>
          </el-row>
          <el-row>
              <el-tooltip  content="选择发起当前流程从属于哪个上级流程，可以形成流程上下级关系。默认可以从企业内所有的业务流程中进行选择。" effect="light" placement="top">
                  <el-form-item label="关联上级流程" v-if="templateInfo.parentProcessInstanceMode"
                    prop="parentProcessInstanceName"
                    :rules="[
                    { required: true, message: '请选择关联上级流程', trigger: 'blur' },
                    ]">
                    <el-input v-if="isTaskProcess" :disabled="isTaskProcess" v-model="processInstanceInfo.parentProcessInstanceName" ></el-input>
                    <el-input v-else @click.native="chooseProcess" v-model="processInstanceInfo.parentProcessInstanceName" ></el-input>
                  </el-form-item>
                  <el-form-item label="关联上级流程" v-else>
                    <el-input v-if="isTaskProcess" :disabled="isTaskProcess" v-model="processInstanceInfo.parentProcessInstanceName" ></el-input>
                    <el-input v-else @click.native="chooseProcess" v-model="processInstanceInfo.parentProcessInstanceName" ></el-input>
                  </el-form-item>
              </el-tooltip>
          </el-row>
          <el-row>
              <el-tooltip  content="默认发起人为流程负责人" effect="light" placement="top">
                  <el-form-item label="流程负责人"  prop="assignedUserId">
                      <el-input readonly v-model="selectedProcessUser.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                      <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg'  :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
                  </el-form-item>
              </el-tooltip>
          </el-row>

          <el-row>
              <el-form-item  label="任务执行方式">
                  <el-radio-group v-model="processInstanceInfo.executeType" size="mini" class="exec-type" @change="changeExecuteType">
                      <el-tooltip content="使用流程模板中配置好的任务负责人信息" placement="top">
                          <el-radio :label="1">默认使用模板配置</el-radio>
                      </el-tooltip>
                      <el-tooltip content="所有任务节点（不包含会签节点）统一使用指定的负责人信息" placement="top">
                          <el-radio :label="2">固定设置任务负责人(不包括会签节点)</el-radio>
                      </el-tooltip>
                      <el-tooltip content="所有任务节点（包含会签节点）统一使用指定的负责人信息" placement="top">
                          <el-radio :label="3">固定设置任务负责人(包括会签节点)</el-radio>
                      </el-tooltip>
                  </el-radio-group>
              </el-form-item>
          </el-row>
          <el-row  v-if="processInstanceInfo.executeType===1">
              <div class="tools-bar" style="float:right;">
                  <div class="tools-btn-group">
                      <el-tooltip content="批量修改任务负责人" placement="top">
                          <el-button type="primary" icon="el-icon-s-check" @click="batchTaskChooseUser">批量任务负责人</el-button>
                      </el-tooltip>
                      <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowBatchTaskAssignerDialog'  :selectedUser="batchTaskSelectedUser" ref="batchTaskUserOrgPop" @nodeClick="batchTaskSelectTrigger"  />
                      <el-tooltip content="复用历史流程的任务负责人，可以快速发起流程" placement="top">
                          <el-button v-if="templateInfo && templateInfo.commonUse" type="primary" icon="el-icon-s-check" @click="handleShowCommonUseConfigSelect">复用历史负责人</el-button>
                      </el-tooltip>
                  </div>
              </div>
              <el-table
                  :data="taskList"
                  :key="taskLoadTimer"
                  style="width: 100%;height:346px;overflow-y:auto"
                  :border="true"
                  @selection-change="handleSelectionTaskRows"
                  tooltip-effect="dark" >
                  <el-table-column  type="index" width="50"> </el-table-column>
                  <el-table-column  type="selection" width="55"></el-table-column>
                  <el-table-column  :show-overflow-tooltip="true" prop="taskName" label="任务节点" ></el-table-column>
                  <el-table-column  width="100"  label="任务类型" >
                      <template slot-scope="scope">
                          <el-tag type="danger" v-if="scope.row.executor.modeType === 2" >会签</el-tag>
                          <el-tag type="warning" v-else-if="scope.row.executor.modeType === 99" >子流程</el-tag>
                          <template  v-else >常规</template>
                      </template>
                  </el-table-column>
                  <el-table-column  :show-overflow-tooltip="true"  label="负责人" width="150">
                      <template slot-scope="scope">
                          <div  v-if="scope.row.executor.modeType === 0 && scope.row.executor.hasOwnProperty('assigneeUsers')" style="cursor:pointer;" @click.stop="handleChooseAssignee(scope.row)">
                              {{scope.row.executor.assigneeUsersName}}
                          </div>
                          <div  v-if="scope.row.executor.modeType === 2 && scope.row.executor.hasOwnProperty('countersignUsers')" style="cursor:pointer;" @click.stop="handleChooseAssignee(scope.row)">
                              {{scope.row.executor.countersignUsersName}}
                          </div>
                          <!-- <div v-else>
                              <el-button size="mini" icon="el-icon-circle-plus-outline" title="添加负责人" circle @click.stop="handleChooseAssignee(scope.row)"></el-button>
                          </div>-->
                          <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectTrigger"  />
                      </template>
                  </el-table-column>
                  <el-table-column  :show-overflow-tooltip="true"  label="候选人(抄送)" width="350">
                    <template slot-scope="scope">
                        <div  v-if="scope.row.executor.modeType === 0 && scope.row.executor.hasOwnProperty('candidateUsers')" style="cursor:pointer;" @click.stop="handleChooseCandidateUsers(scope.row)">
                            {{scope.row.executor.candidateUsersName}}
                        </div>
                        <UserOrgPop :key="loadTimer" :multiple="true" :isShowUserOrg='isShowCandidateUserOrg'  :selectedUser="selectedCandidateUser" ref="candidateUserOrgPop" @nodeClick="selectCandidateUserTrigger2"  />
                    </template>
                </el-table-column>
                  <el-table-column  width="120"  label="操作" >
                      <template slot-scope="scope">
                          <el-button type="primary" size="mini" icon="el-icon-user" title="编辑负责人" circle @click.stop="handleChooseAssignee(scope.row)"></el-button>
                          <el-button type="success" size="mini" icon="el-icon-user" title="编辑候选人" circle @click.stop="handleChooseCandidateUsers(scope.row)"></el-button>
                      </template>
                  </el-table-column>
              </el-table>
          </el-row>
          <el-row  v-if="processInstanceInfo.executeType>=2">
              <el-form-item label="任务负责人"  prop="assignedUserId"
                  :rules="[
                    { required: true, message: '请输入任务负责人', trigger: 'change' },
                  ]">
                    <!--<User ref="userChild" :field="{}"  :formData="{}" @nodeClick="selectTrigger"/>-->
                      <el-input readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                      <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectTrigger"  />
              </el-form-item>
          </el-row>
          <el-row  v-if="processInstanceInfo.executeType>=2">
              <el-form-item label="任务候选人"  prop="candidateUsers">
                  <el-input readonly v-model="selectedCandidateUser.selectedUserNames" @focus="chooseCandidateUser" ></el-input>
                  <UserOrgPop :key="loadTimer" :multiple="true" :isShowUserOrg='isShowCandidateUserOrg'  :selectedUser="selectedCandidateUser" ref="candidateUserOrgPop" @nodeClick="selectCandidateUserTrigger"  />
              </el-form-item>
          </el-row>
      </el-form>
      <span style="float: right;margin-top: 20px;">
          <el-button @click="handleClosePop">取 消</el-button>
          <el-button type="primary" @click="handleSaveStartProcess" :loading="startProcessloading" v-preventReClick = "3000">确 定</el-button>
      </span>
       <el-dialog
          title="选择所属流程"
          :visible.sync="isShowProcessListDialog"
          append-to-body
          width = "60%">
          <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="selectProcessTrigger" :unNeedAuth="true"/>
      </el-dialog>
      <el-dialog
          title="选择所属流程"
          :visible.sync="isShowProcessPop"
          append-to-body
          top="4vh"
          width="95%"
          >
          <ProcessSelectPop ref="processPop" :multiple="false" :selectedProcess="selectedProcess" :formData="{}" :field="{}" @nodeClick="selectProcessTrigger" />
      </el-dialog>
      <!-- <ProcessSelectPop
          :multiple="false"
          :isShowProcessPop="isShowProcessPop"
          :selectedProcess="selectedProcess"
          :formData="{}"
          :field="{}"
          @nodeClick="selectProcessTrigger"
          ref="processPop"
        /> -->
      <el-dialog
          title="选择会签人员"
          :visible.sync="isShowExecutorsDialog"
          top="3vh"
          append-to-body
          :before-close="handleExecutorClose"
          width = "80%">
            <ExecutorEdit :key="loadTimer" :executor='executor' />
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleExecutorClose">取 消</el-button>
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span>
      </el-dialog>
      <el-dialog
          title="任务详情"
          custom-class="needWorkingPop"
          append-to-body
          :visible.sync="isShowTaskDetail"
          :fullscreen="true"
          @close="handleClose"
          width = "90%">
          <!-- <div> -->
            <TaskDetail
                :taskInfo="firstTaskInfo"
                :key="loadTimer"
                @taskComplete="handleTaskComplete"
                @taskDelete="handleTaskDelete"
                @taskHidden="handleTaskHidden"
                @taskTemporarySave="handleTaskTemporarySave"
                @transferTask="transferTask"
            />
          <!-- </div> -->
      </el-dialog>
      <el-dialog
          title="选用历史流程负责人"
          :visible.sync="isShowCommonUseConfigDialog"
          append-to-body
          width = "50%">
          <ProcessCommonUseConfigSelect :key="loadTimer" ref="processCommonUseConfigSelect" :processServiceId="processInstanceInfo.processServiceId" :deploymentId="processInstanceInfo.deploymentId" @nodeClick="commonUseConfigSelectTrigger"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowCommonUseConfigDialog = false" >取 消</el-button>
              <el-button type="primary" v-preventReClick = "3000" @click="commonUseConfigSelectConfirm">确定</el-button>
          </span>
      </el-dialog>
  </el-main>
</template>

<script>
  import { getSerialNumberDepAndOption, processTaskHidden, processTaskTemporarySave, processTaskComplete, processTaskDelete, transferAssignee, getProcessTaskDetail, getProcessInstancesCnt, getSerialNumber, getUserList, getProcessServiceTemplate, getAllUserTask, startProcess, getSerialNumberDepartment, getSerialNumberPlus } from '@/data-model';
  import mixinsNav from '@/mixins/mixins-nav';
  import { isEmpty, clone, cloneDeep } from 'lodash';
  import TemplatePop from './TemplatePop';
  import ExecutorEdit from '../ProcessEditor/components/ExecutorEdit';
  import TaskDetail from '@/pages/process/MyTask/TaskDetail';
  import { CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN,
      CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN,
      CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN,
      CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN,
      CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
  } from '@/common/constants';

  export default {
      components: {
          TaskDetail,
          TemplatePop,
          ExecutorEdit
      },
      mixins: [ mixinsNav ],
      data () {
          return {
              selectedProcess: {
                  processIds: '',
                  selectedProcessNames: ''
              },
              isShowProcessPop: false,
              selectedHisProcessTaskList: '',
              isShowCommonUseConfigDialog: false,
              firstTaskInfo: {}, // 流程实例首任务详情
              currentUserInfo: {},
              isShowTaskDetail: false, // 任务详情
              canViewProcessDetail: false,
              startedProcessInstance: {}, // 发起流程后，返回的流程实例信息
              isShowBatchTaskAssignerDialog: false,
              batchTaskSelectedUser: {
                  selectedUserIds: '',
                  selectedUserNames: ''
              },
              batchAuthTaskList: [], // 当前选择的批量任务列表
              currentExecutors: [], // 任务节点执行人，用于模式executeType=3时，更新会签任务的信息
              executor: {},
              executorMap: new Map(),
              countersignList: [],
              isShowExecutorsDialog: false,
              isShowProcessListDialog: false,
              reSetLoading: false,
              isShowProcessUserOrg: false,
              selectedProcessUser: {
                  selectedUserIds: '',
                  selectedUserNames: ''
              },
              selectedCandidateUser: {
                  selectedUserIds: '',
                  selectedUserNames: ''
              },
              isShowCandidateUserOrg: false,
              selectedUser: {
                  selectedUserIds: '',
                  selectedUserNames: ''
              },
              isShowUserOrg: false,
              taskLoadTimer: '',
              loadTimer: '',
              workflowProcessType: 'edit',
              workflowProcessDefinitionId: '',
              workflowProcessServiceId: '',
              workflowDeploymentId: '',
              isShowConsole: false,
              activeClass: -1,
              tabName: 'first',
              archiveTemplateList: [],
              userList: [],
              isShowSetting: false,
              processState: [
                  {
                      value: 1,
                      label: '最新版'
                  }, {
                      value: 2,
                      label: '全部版本'
                  }
              ],
              processDefineList: [{
                  value: '',
                  label: '全部'
              }],
              templateList: [],
              searchParams: {
                  key: '',
                  serviceName: '',
                  definitionName: '',
                  state: 1 // 版本范围 ：默认 最新版
              },
              taskList: [],
              archiveTemplateTreeList: [],
              processInstance: {
                  processServiceName: '',
                  name: ''
              },
              isShowStartProcessDialog: false,
              startProcessloading: false,
              processInstanceInfo: {
                  processServiceId: '',
                  instanceName: '',
                  deploymentId: '',
                  executeType: 1, // 1由已配置的负责人执行   2固定设置所有节点的任务负责人
                  assignedUserId: '',
                  candidateUsers: '',
                  parentProcessInstanceId: '',
                  parentProcessInstanceName: ''
              },
              isShowTemplateDesc: false, //
              templateInfo: {
                  processServiceName: '',
                  processServiceId: '',
                  deploymentId: '',
                  id: '',
                  templateName: '',
                  templateDesc: '',
                  archiveTemplateId: '', // 档案模板
                  archiveTemplateName: '',
                  timeTemplateId: '', // 项目模板
                  timeTemplateName: '',
                  closeTemplateId: '', // 闭环模板
                  closeTemplateName: '',
                  processServiceType: '',
                  nameGenerationMode: '',
                  defaultFirstAssignee: 0, // 是否默认首任务负责人为发起人
                  parentProcessInstanceMode: 0, // 关联上级流程是否必填：0否1是，默认为0
                  processTaskAssignerMode: 0, // 流程所有任务的负责人是否必填：0否1是，默认为0
                  autoCompleteTask: 0,
                  canViewAllFile: 0,
                  claimMode: 0, // 任务认领模式
                  completeFirstTask: 0, // 是否立即执行首任务
                  planTimeMode: 0, // 默认不进行默认计划时间
                  processViewPanes: null,
                  taskViewPanes: null,
                  processExtJson: null,
                  dataOperate: {
                      dataSource: 2,
                      forms: []
                  }
              },
              businessTree: [],
              saveMode: 0, // 0:修改 1发布
              permission: {
                  startProcessTemplateBtn: [
                      CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN
                  ],
                  designProcessTemplateBtn: [
                      CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                  ],
                  publishProcessTemplateBtn: [
                      CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN
                  ],
                  previewProcessTemplateBtn: [
                      CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN
                  ],
                  configProcessTemplateBtn: [
                      CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
                  ]
              },
              initSelectedUsers: [], // 任务负责人
              selectedTask: {},
              selectedMap: new Map(),
              isTaskProcess: false
          };
      },
      created () {
          this._queryUserList('');
          this.isTaskProcess = false;
          this.executorMap = new Map();
          this.countersignList = [];

          // 跳转我的流程权限
          let currentUserStr = sessionStorage.getItem('currentUserInfo');
          let currentUserInfo = JSON.parse(currentUserStr);
          this.currentUserInfo = currentUserInfo;
          let resources = currentUserInfo.resources;
          if (resources) {
              resources.forEach(item => {
                  // console.log(item.resourceDes);
                  if (item.resourceDes === 'process/myProcess/:processInstanceId') {
                      this.canViewProcessDetail = true;
                  }
              });
          }
      },
      computed: {
          candidateSelectFields: {
              get () {
                  if (isEmpty(this.processInstanceInfo.candidateUsers)) {
                      return [];
                  }
                  return this.processInstanceInfo.candidateUsers.split(',');
              },
              set (newVal, oldVal) {
                  this.processInstanceInfo.candidateUsers = newVal.join(',');
              }
          }
      },
      watch: {
      },
      props: {
          isDialogChoose: {
              type: Boolean,
              default: false
          },
          isShowOrder: {
              type: Boolean,
              default: false
          },
          isMulti: {
              type: Boolean,
              default: false
          },
          taskInfo: {
              type: Object
          },
          isReturnToNav: {
              type: Boolean,
              default: false
          },
          fromWorkAssistant: {
              type: Boolean,
              default: false
          },
          isNewModePage: {// 是否是新模式页面
              type: Boolean,
              default: false
          }
      },
      methods: {
          async handleStartProcess (process) {
              this.isTaskProcess = false;
              // this.loadTimer = new Date().getTime();
              if (process.parentProcessInstanceId) {
                  this.processInstanceInfo.parentProcessInstanceId = process.parentProcessInstanceId;
                  this.processInstanceInfo.parentProcessInstanceName = process.parentProcessInstanceName;
                  this.isTaskProcess = true;
              }
              this.processInstanceInfo.instanceName = '';
              await this.createProjectName(process);
              this.processInstanceInfo.executeType = 1;
              this.batchTaskSelectedUser = {
                  selectedUserIds: '',
                  selectedUserNames: ''
              };
              this.selectedUser = {
                  selectedUserIds: '',
                  selectedUserNames: ''
              };
              this.selectedCandidateUser = {
                  selectedUserIds: '',
                  selectedUserNames: ''
              };
              let currentUserStr = sessionStorage.getItem('currentUserInfo');
              let currentUserInfo = JSON.parse(currentUserStr);
              this.selectedProcessUser = {// 默认流程负责人为发起人
                  selectedUserIds: currentUserInfo.userId,
                  selectedUserNames: currentUserInfo.trueName
              };
              this.processInstanceInfo.id = process.id;
              this.processInstanceInfo.processServiceId = process.processServiceId;
              this.processInstanceInfo.deploymentId = process.deploymentId;
              // console.log(process);
              // console.log(this.processInstanceInfo);
              this.taskList = [];
              await this.changeExecuteType(1);

              if (this.taskList && this.taskList.length > 0) {
                  // 默认首任务负责人
                  // console.log(this.templateInfo.defaultFirstAssignee);
                  if (this.templateInfo.defaultFirstAssignee) {
                      // let firstTaskNode = this.taskList[0];
                      // if (firstTaskNode.executor.modeType === 0 && isEmpty(firstTaskNode.executor.assigneeUsers)) {
                      //     firstTaskNode.executor.assigneeUsers = currentUserInfo.userId;
                      //     firstTaskNode.executor.assigneeUsersName = currentUserInfo.trueName;
                      // }
                      for (let i = 0; i < this.taskList.length; i++) {
                          let taskNode = this.taskList[i];
                          for (let j = 0; j < this.templateInfo.firstTaskUserIds.length; j++) {
                              let currentTaskId = this.templateInfo.firstTaskUserIds[j];
                              if (taskNode.taskId === currentTaskId) {
                                  if (taskNode.executor.modeType === 0 && isEmpty(taskNode.executor.assigneeUsers)) {
                                      taskNode.executor.assigneeUsers = currentUserInfo.userId;
                                      taskNode.executor.assigneeUsersName = currentUserInfo.trueName;
                                  }
                              }
                          }
                      }
                  }
                  // 会签节点任务如果没设置值,则默认为空
                  for (var i = 0; i < this.taskList.length; i++) {
                      let taskNode = this.taskList[i];
                      if (taskNode.executor.modeType === 2) { // 会签任务
                          // 校验会签人员是否存在
                          if (isEmpty(taskNode.executor.countersignUsers)) {
                              taskNode.executor.countersignUsers = '';
                              taskNode.executor.countersignUsersName = '';
                          }
                      }
                  }
                  this.loadTimer = new Date().getTime();
                  this.taskLoadTimer = new Date().getTime();
              }

              this.isShowStartProcessDialog = true;
              // this.startProcessloading = false;
          },
          async createProjectName (process) {
              let template = await getProcessServiceTemplate(process.processServiceId, process.deploymentId);
              this.templateInfo.commonUse = template.commonUse;
              this.templateInfo.defaultFirstAssignee = template.defaultFirstAssignee;
              this.templateInfo.parentProcessInstanceMode = template.parentProcessInstanceMode;
              this.templateInfo.processTaskAssignerMode = template.processTaskAssignerMode;
              this.templateInfo.autoCompleteTask = template.autoCompleteTask;
              this.templateInfo.canViewAllFile = template.canViewAllFile;
              this.templateInfo.claimMode = template.claimMode;
              this.templateInfo.completeFirstTask = template.completeFirstTask;
              this.templateInfo.processViewPanes = template.processViewPanes;
              this.templateInfo.taskViewPanes = template.taskViewPanes;
              this.templateInfo.processExtJson = template.processExtJson;
              this.templateInfo.planTimeMode = template.planTimeMode;
              this.templateInfo.nameGenerationMode = template.nameGenerationMode ? template.nameGenerationMode : '';
              this.templateInfo.serialNumberJson = template.serialNumberJson ? template.serialNumberJson : '';
              this.templateInfo.firstTaskUserIds = template.firstTaskUserIds; // 首任务taskId的list
              if (this.templateInfo.nameGenerationMode && this.templateInfo.serialNumberJson) {
                  let node = JSON.parse(this.templateInfo.serialNumberJson);
                  if (this.templateInfo.nameGenerationMode === 'single') { // 单选
                      await this.setSerialNumber(node.value);
                  } else if (this.fieldSubType === 'multi') {
                      setTimeout(() => { // 默认回显值
                          this.$refs.treeChild._refreshSelectedNode(node);
                      }, 0);
                  }
              }
          },
          async setSerialNumber (sid) {
              let numberObj = await getSerialNumber(sid);
              // console.log(numberObj);
              this.processInstanceInfo.instanceName = numberObj.newSerialNumber;
              this.processInstanceInfo.recordId = numberObj.sn;
          },
          async reSetSerialNumber () {
              this.reSetLoading = true;
              let node = JSON.parse(this.templateInfo.serialNumberJson);
              if (this.templateInfo.nameGenerationMode === 'single') { // 单选
                  await this.setSerialNumber(node.value);
              }
              this.reSetLoading = false;
          },
          async handleSaveStartProcess () {
              let isValid = false;
              this.$refs['processInstanceForm'].validate((valid) => {
                  if (valid) {
                  // alert('submit!');
                      isValid = true;
                  } else {
                      isValid = false;
                  }
              });
              if (!isValid) {
                  return false;
              }
              if (this.processInstanceInfo.instanceName.trim() === '') {
                  this.$message({message: '流程实例名称不能为空', type: 'warning'});
                  return false;
              }
              if (this.templateInfo.parentProcessInstanceMode && !this.processInstanceInfo.parentProcessInstanceId) {
                  this.$message({message: '关联上级流程不能为空', type: 'warning'});
                  return false;
              }
              // 校验任务中会签人员是否已选择(会签不支持干预，需提前选择好)
              // console.log(this.taskList);
              for (var i = 0; i < this.taskList.length; i++) {
                  let item = clone(this.taskList[i]);
                  if (this.processInstanceInfo.executeType < 3 && item.executor.modeType === 2) { // 会签任务
                      // 校验会签人员是否存在
                      if (isEmpty(item.executor.countersignUsers)) {
                          this.$message({message: '存在未配置负责人会签节点，请配置后再发起', type: 'warning'});
                          return false;
                      }
                  } else if (this.processInstanceInfo.executeType < 3 && this.templateInfo.processTaskAssignerMode && isEmpty(item.executor.assigneeUsers)) {
                      this.$message({message: '当前流程模板设置必须选择任务负责人，存在未配置负责人的任务节点，请配置后再发起', type: 'warning'});
                      return false;
                  }
              }

              let cntMap = await getProcessInstancesCnt(this.processInstanceInfo);
              if (cntMap.processInstanceCnt > 0) {
                  this.$confirm(`存在重名的流程实例名称,您确定要发起吗？`, '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(async (res) => {
                      this.startProcessPre();
                  }).catch((error) => {
                      console.error(error);
                      return false;
                  });
              } else {
                  this.startProcessPre();
              }
          },
          startProcessPre () {
              // 如果设置了立即执行首任务的配置，需要在此校验
              // 选择了模式1，并设置了立即完成首任务
              if (this.processInstanceInfo.executeType === 1 && this.templateInfo.completeFirstTask === 1) {
                  let firstTaskNode = this.taskList[0];
                  if (firstTaskNode.executor.assigneeUsers !== this.currentUserInfo.userId) {
                      this.$confirm(`当前流程模板设置了立即执行首任务的配置,是否将首任务改为自己后再发起流程？`, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                      }).then(async (res) => {
                          return false;
                      }).catch(() => {
                          this.startProcess();
                      });
                  } else {
                      this.startProcess();
                  }
              } else {
                  this.startProcess();
              }
          },
          async startProcess () {
              this.startProcessloading = true;
              let loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              // this.processInstanceInfo.executorMap = null;
              // this.executorMap = null;
              if (this.processInstanceInfo.executeType === 1) {
                  let assignedUserList = [];
                  // this.executorMap = new Map();
                  this.taskList.forEach(item => {
                      let assignedUserId = '';
                      let assigneeUserName = '';
                      let candidateUsers = '';
                      let candidateUsersName = '';
                      if (item.hasOwnProperty('assignedUserId')) {
                          assignedUserId = item.assignedUserId;
                          assigneeUserName = item.assigneeUserName;
                      } else if (item.executor.hasOwnProperty('assigneeUsers')) {
                          assignedUserId = item.executor.assigneeUsers;
                          assigneeUserName = item.executor.assigneeUsersName;
                      }
                      if (item.executor.hasOwnProperty('candidateUsers')) {
                          candidateUsers = item.executor.candidateUsers;
                          candidateUsersName = item.executor.candidateUsersName;
                      }
                      assignedUserList.push({taskId: item.taskId, taskName: item.taskName, assignedUserId: assignedUserId, assigneeUserName: assigneeUserName, candidateUsers: candidateUsers, candidateUsersName: candidateUsersName});
                  //  this.executorMap.set(newVal, this.templateList[i]);
                  });
                  // this.executorMap.set('001', this.executor);
                  this.processInstanceInfo.countersignList = this.countersignList;
                  this.processInstanceInfo.executorMap = this.executorMap;
                  this.processInstanceInfo.assignedUserList = assignedUserList;
              }

              // 模式3情况下，处理会签任务节点
              if (this.processInstanceInfo.executeType === 3) {
                  let tasks = await getAllUserTask(null, this.processInstanceInfo.processServiceId, this.processInstanceInfo.id, this.processInstanceInfo.deploymentId);
                  this.countersignList = [];
                  tasks.forEach(item => {
                      let executorTemp = cloneDeep(item);
                      if (executorTemp.executor.modeType === 2) {
                          let currentUser = this.getUsers(this.processInstanceInfo.assignedUserId);
                          if (currentUser) {
                              executorTemp.executor.taskId = executorTemp.taskId;
                              executorTemp.executor.isInitconfig = true;
                              executorTemp.executor.countersignUsers = this.processInstanceInfo.assignedUserId;
                              executorTemp.executor.countersignUsersName = currentUser.trueName;
                              this.changeExecutors(executorTemp.executor.countersignUsers);
                              executorTemp.executor.executors = this.currentExecutors;
                              this.countersignList.push(executorTemp.executor);
                          }
                      }
                  });
                  this.processInstanceInfo.countersignList = this.countersignList;
              }

              // this.startProcessloading = true;
              if (this.taskInfo) {
                  this.processInstanceInfo.relationProcessInstanceId = this.taskInfo.processInstanceId;
                  this.processInstanceInfo.relationTaskInstanceId = this.taskInfo.id;
                  this.processInstanceInfo.relationTaskDefinedId = this.taskInfo.taskDefinitionKey;
              }
              // 调用发起流程的接口
              try {
                  this.startedProcessInstance = await startProcess(this.processInstanceInfo);
              } catch (error) {
                  this.startProcessloading = false;
                  loading.close();
                  console.error(error);
                  return;
              }
              // this.startedProcessInstance = await startProcess(this.processInstanceInfo);
              loading.close();
              this.startProcessloading = false;
              this.isShowStartProcessDialog = false;
              // console.log(this.templateInfo.completeFirstTask);
              // 立即执行首任务的配置
              if (this.templateInfo.completeFirstTask === 1) {
                  // console.log(this.taskList[0].executor.assigneeUsers);
                  if (this.taskList[0].executor.assigneeUsers === this.currentUserInfo.userId) {
                      // 弹出任务详情
                      if (isEmpty(this.startedProcessInstance.firstTaskInstanceIds)) {
                          this.messageTip('任务信息找不到,请检查该流程是否发起成功或联系管理员处理', 'warning');
                          return false;
                      } else {
                          let firstTaskIdArray = this.startedProcessInstance.firstTaskInstanceIds.split(',');
                          if (firstTaskIdArray && firstTaskIdArray.length > 1) {
                              // this.messageTip('还有多个任务,请到我的任务列表进行处理', 'warning');
                              if (this.currentUserInfo.switchLayoutFlg === 2) {
                                  if (this.isReturnToNav) {
                                      this.$emit('navToBusiniessTaskTab');// 2.0版 跳转到tab页签
                                  } else {
                                      this.navMyTaskMyAssignee();// 2.0版 我负责我任务
                                  }
                              } else {
                                  this.navMyTask();// 1.0版 我的任务
                              }
                              return false;
                          }
                          if (firstTaskIdArray.length === 1) {
                              this.firstTaskInfo = await getProcessTaskDetail(firstTaskIdArray[0]);
                              this.isShowTaskDetail = true;
                          }
                      }
                  } else {
                      this.jumpToPage();
                  }
              } else {
                  this.jumpToPage();
              }
          },
          chooseUser () {
              this.loadTimer = new Date().getTime();
              setTimeout(() => { // 初始化
                  this.$refs.userOrgPop._initPage();
              }, 0);
              this.isShowUserOrg = true;
          },
          selectTrigger (selected) { // 常规任务负责人选择
              this.selectedUser = selected;
              this.processInstanceInfo.assignedUserId = selected.selectedUserIds;
              this.selectedTask.assignedUserId = selected.selectedUserIds;
              this.selectedTask.assigneeUserName = selected.selectedUserNames;
              if (this.selectedTask.hasOwnProperty('executor')) {
                  this.selectedTask.executor.assigneeUsers = selected.selectedUserIds;
                  this.selectedTask.executor.assigneeUsersName = selected.selectedUserNames;
              }
              // this.loadTimer = new Date().getTime();
              this.taskLoadTimer = new Date().getTime();
              // console.log(this.processInstanceInfo.assignedUserId);
          },
          chooseCandidateUser () {
              this.loadTimer = new Date().getTime();
              setTimeout(() => { // 初始化
                  this.$refs.candidateUserOrgPop._initPage();
              }, 0);
              this.isShowCandidateUserOrg = true;
          },
          selectCandidateUserTrigger (selected) {
              this.selectedCandidateUser = selected;
              this.processInstanceInfo.candidateUsers = selected.selectedUserIds;
          },
          selectCandidateUserTrigger2 (selected) {
              this.selectedCandidateUser = selected;
              if (this.selectedTask.hasOwnProperty('executor')) {
                  this.selectedTask.executor.candidateUsers = selected.selectedUserIds;
                  this.selectedTask.executor.candidateUsersName = selected.selectedUserNames;
              }
              this.taskLoadTimer = new Date().getTime();
          },
          handleTreeNode (data, node, tree) {
              this.templateInfo.processServiceType = data.id;
          },
          async changeExecuteType (executeType) {
              this.batchAuthTaskList = [];
              if (executeType === 1) {
                  let loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  let tasks = await getAllUserTask(null, this.processInstanceInfo.processServiceId, this.processInstanceInfo.id, this.processInstanceInfo.deploymentId);
                  this.taskList = tasks;
                  loading.close();
              }
          },
          handleChooseAssignee (row) {
              this.executor = {};
              if (row.executor.modeType === 2) {
                  this.executor = row.executor;
                  this.executor.taskId = row.taskId;
                  this.executor.isInitconfig = true;
                  this.isShowExecutorsDialog = true;
              } else {
                  this.loadTimer = new Date().getTime();
                  setTimeout(() => { // 初始化
                      this.$refs.userOrgPop._initPage();
                  }, 0);
                  this.isShowUserOrg = true;
                  this.selectedTask = row;
                  if (row.executor.hasOwnProperty('assigneeUsers')) {
                      this.selectedUser.selectedUserIds = row.executor.assigneeUsers;
                      this.selectedUser.selectedUserNames = row.executor.assigneeUsersName;
                  } else {
                      this.selectedUser = {};
                  }
              // console.log(this.selectedTask);
              // this.initSelectedUsers = [];
              }
          },
          chooseProcessAssigneeUser () {
              this.loadTimer = new Date().getTime();
              setTimeout(() => { // 初始化
                  this.$refs.processUserOrgPop._initPage();
              }, 0);
              this.isShowProcessUserOrg = true;
          },
          processAssigneeSelectTrigger (selected) { // 流程负责人
              this.selectedProcessUser = selected;
              this.processInstanceInfo.assigneeUserId = selected.selectedUserIds;
              this.loadTimer = new Date().getTime();
          },
          handleClosePop () {
              this.$emit('handleClosePop');
          },
          handleChooseCandidateUsers (row) {
              this.executor = {};
              this.loadTimer = new Date().getTime();
              setTimeout(() => { // 初始化
                  this.$refs.candidateUserOrgPop._initPage();
              }, 0);
              this.isShowCandidateUserOrg = true;
              this.selectedTask = row;
              if (row.executor.hasOwnProperty('candidateUsers')) {
                  this.selectedCandidateUser.selectedUserIds = row.executor.candidateUsers;
                  this.selectedCandidateUser.selectedUserNames = row.executor.candidateUsersName;
              } else {
                  this.selectedCandidateUser = {};
              }
          },
          chooseProcess () {
              // this.isShowProcessListDialog = true;
              this.isShowProcessPop = true;
              // // 初始化
              // if (this.$refs.processPop) {
              //     this.$refs.processPop._initPage();
              // }
          },
          selectProcessTrigger (selected) { // 选择流程
              // this.processInstanceInfo.parentProcessInstanceId = selected.id;
              // this.processInstanceInfo.parentProcessInstanceName = selected.label;
              // this.isShowProcessListDialog = false;
              this.processInstanceInfo.parentProcessInstanceId = selected.selectedProcessIds;
              this.processInstanceInfo.parentProcessInstanceName = selected.selectedProcessNames;
              this.isShowProcessPop = false;
          },
          handleExecutorClose (done) {
              this.$confirm('确认当前会签人员设置？')
                  .then(_ => {
                      this.handleClickOk();
                      done();
                  })
                  .catch(_ => {});
          },
          async handleClickOk () { // 会签人员选择确定
              this.isShowExecutorsDialog = false;
              // console.log('选择的会签人员');
              // console.log(this.executor);
              if (!this.executorMap) {
                  this.executorMap = new Map();
              }
              let executorTemp = cloneDeep(this.executor);
              // 如果选用了复用历史任务后，再次修改，则需要删除
              // if (this.countersignList != null && this.countersignList.length > 0) {
              //     for (let i = 0; i < this.countersignList.length; i++) {
              //         if (this.countersignList[i].taskId === this.executor.taskId) {
              //             this.countersignList[i].splice(i, 1);
              //         }
              //     }
              // }
              if (!this.executorMap.has(this.executor.taskId)) {
                  this.countersignList.push(executorTemp);
              } else {
                  this.countersignList.forEach(item => {
                      if (item.taskId === this.executor.taskId) {
                          item = executorTemp;
                          // this.countersignList.push(executorTemp);
                      }
                  });
              }
              this.taskLoadTimer = new Date().getTime();
          },
          changeExecutors (selVal) { // selVal是以逗号隔开的用户ID字符串
              this.currentExecutors = [];
              if (Array.isArray(selVal)) {
                  selVal.forEach(item => {
                      this.changeSelVal(item);
                  });
              } else {
                  this.changeSelVal(selVal);
              }
              this.selectItem = '';
          },
          changeSelVal (item) {
              let user = this.getUsers(item);
              if (user) {
                  this.currentExecutors.push({
                      userId: item,
                      trueName: user.trueName,
                      executionOrder: this.currentExecutors.length
                  });
              }
          },
          getUsers (id) {
              let user = this.userList.find((item) => {
                  return item.userId === id;
              });
              return user;
          },
          async _queryUserList () {
              let userData = await getUserList();
              let sourceUsers = cloneDeep(userData.data);
              this.userList = [];
              sourceUsers.forEach(item => {
                  this.userList.push(item);
              });
              return userData.data;
          },
          handleSelectionTaskRows (rows) {
              this.batchAuthTaskList = rows;
              // console.log(this.batchAuthTaskList);
          },
          batchTaskChooseUser () { // 批量选任务分责人
              if (this.batchAuthTaskList && this.batchAuthTaskList.length > 0) {
                  // 判断是否选了会签节点
                  let hasCounterTask = false;
                  for (var i = 0; i < this.batchAuthTaskList.length; i++) {
                      if (this.batchAuthTaskList[i].executor.modeType === 2 || this.batchAuthTaskList[i].executor.modeType === 99) {
                          hasCounterTask = true;
                          break;
                      }
                  }
                  if (hasCounterTask) { // 会签节点不支持批量选人
                      this.$message({message: '只支持常规任务的负责人批量修改，请修改已经勾选的任务列表', type: 'warning'});
                  } else {
                      this.loadTimer = new Date().getTime();
                      setTimeout(() => { // 初始化
                          this.$refs.batchTaskUserOrgPop._initPage();
                      }, 0);
                      this.isShowBatchTaskAssignerDialog = true;
                  }
              } else {
                  this.$message({message: '请先选择需要修改负责人的任务', type: 'warning'});
                  return false;
              }
          },
          batchTaskSelectTrigger (selected) { // 批量选择任务负责人
              this.isShowBatchTaskAssignerDialog = false;
              this.batchTaskSelectedUser = selected;
              this.batchTaskSelectedUser.assignedUserId = selected.selectedUserIds;
              this.batchTaskSelectedUser.assigneeUserName = selected.selectedUserNames;
              // console.log(this.batchTaskSelectedUser);
              this.taskList.forEach(item => {
                  // let assignedUserId = '';
                  // let assigneeUserName = '';
                  let isSelectTask = false;
                  for (var i = 0; i < this.batchAuthTaskList.length; i++) {
                      if (this.batchAuthTaskList[i].taskId === item.taskId) {
                          isSelectTask = true;
                          break;
                      }
                  }
                  if (isSelectTask) {
                      item.executor.assigneeUsers = this.batchTaskSelectedUser.assignedUserId;
                      item.executor.assigneeUsersName = this.batchTaskSelectedUser.assigneeUserName;
                      item.executor.countersignUsers = this.batchTaskSelectedUser.assignedUserId;
                      item.executor.countersignUsersName = this.batchTaskSelectedUser.assigneeUserName;
                  }
              });
              this.taskLoadTimer = new Date().getTime();
              // 初始化变量值
              this.batchAuthTaskList = [];
              this.batchTaskSelectedUser = {
                  selectedUserIds: '',
                  selectedUserNames: ''
              };
          },
          async handleTaskComplete (taskData) {
              let task = {
                  taskDefinitionKey: this.firstTaskInfo.taskDefinitionKey,
                  processInstanceId: this.firstTaskInfo.processInstanceId,
                  processServiceId: this.firstTaskInfo.processServiceId,
                  deploymentId: this.firstTaskInfo.processDefinitionDeploymentId,
                  taskId: this.firstTaskInfo.id,
                  operateType: taskData.operateType,
                  btnConditions: taskData.btnConditions,
                  operateOpinion: taskData.operateOpinion,
                  forms: taskData.forms,
                  modelInstanceIds: taskData.modelInstanceIds,
                  isApproval: this.firstTaskInfo.taskNode.isApproval,
                  canUnStartApproval: this.firstTaskInfo.taskNode.canUnStartApproval,
                  isSubProcess: this.firstTaskInfo.taskNode.isSubProcess,
                  needAllSubProcess: this.firstTaskInfo.taskNode.needAllSubProcess,
                  mainModelInfo: taskData.mainModelInfo,
                  operateName: taskData.operateName,
                  mainDataModelInstanceIds: taskData.mainDataModelInstanceIds
              };
              let loading;
              try {
                  loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  if (this.firstTaskInfo.formObj) {
                      await this.renderSerialNumber(this.firstTaskInfo.formObj.structure, task.forms, taskData.operateType);
                  }
                  await processTaskComplete(task);
                  loading.close();
                  this.isShowTaskDetail = false;
                  this.jumpToPage();
              } catch (error) {
                  console.error('任务保存出错：' + error);
                  loading.close();
              }
          },
          async handleTaskDelete () {
              // console.log(task);
              this.$confirm(`您确定要删除任务吗？`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(async (res) => {
                  const loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  await processTaskDelete(this.firstTaskInfo.processInstanceId, this.firstTaskInfo.id);
                  loading.close();
                  this.isShowTaskDetail = false;
                  this.jumpToPage();
              }).catch(() => {});
          },
          async handleTaskHidden () {
              // console.log(task);
              this.$confirm(`您确定要隐藏任务吗？`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(async (res) => {
                  const loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  await processTaskHidden({processInstanceId: this.firstTaskInfo.processInstanceId, taskInstanceId: this.firstTaskInfo.id});
                  loading.close();
                  this.isShowTaskDetail = false;
                  this.jumpToPage();
              }).catch(() => {});
          },
          async handleTaskTemporarySave (taskData) {
              let task = {
                  taskDefinitionKey: this.firstTaskInfo.taskDefinitionKey,
                  processInstanceId: this.firstTaskInfo.processInstanceId,
                  processServiceId: this.firstTaskInfo.processServiceId,
                  deploymentId: this.firstTaskInfo.processDefinitionDeploymentId,
                  taskId: this.firstTaskInfo.id,
                  forms: taskData.forms,
                  btnConditions: taskData.btnConditions,
                  modelInstanceIds: taskData.modelInstanceIds,
                  operateOpinion: taskData.operateOpinion,
                  mainModelInfo: taskData.mainModelInfo
              };
              const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              try {
                  await this.renderSerialNumber(this.firstTaskInfo.formObj.structure, task.forms, '1');// 1:代表完成，暂存于完成生成流水号规则一致
                  await processTaskTemporarySave(task);
                  await this.handleTaskDetail(this.firstTaskInfo.id);
                  loading.close();
              } catch (error) {
                  console.log(error);
              } finally {
                  loading.close();
              }
          },
          async handleTaskDetail (id) {
              this.firstTaskInfo = await getProcessTaskDetail(id);
              this.loadTimer = new Date().getTime();
          },
          async transferTask (param) {
              this.$confirm(`您确定要转办任务吗？`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(async (res) => {
                  await transferAssignee(param);
                  this.jumpToPage();
              }).catch(() => {});
          },
          async renderSerialNumber (forms, formData, operateType) {
              // operateType,1:完成（即保存），2：同意/通过（即审批通过）
              if (forms && formData && forms.length > 0 && formData.length > 0) {
                  for (var dIndex = 0; dIndex < formData.length; dIndex++) {
                      // if (formData[dIndex].values.id) {
                      //     continue;
                      // }
                      let fData = formData[dIndex];
                      for (var findex = 0; findex < forms.length; findex++) {
                          let formInfo = forms[findex];
                          // 流水号保存生成字段渲染
                          if (fData.formId === formInfo.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                              for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                  let field = formInfo.fieldsList[fieldIndex];
                                  // 假如是流水号字段并且流水号有值的情况下就不走流水号生成逻辑了
                                  if (field.type === 'serialNumber' && !isEmpty(fData.values[field.id])) {
                                      console.log(field.name + '---------' + field.type);
                                      console.log(fData.values[field.id]);
                                      continue;
                                  }
                                  if (field.type === 'subform' && fData.values[field.id] && fData.values[field.id].length > 0) {
                                      for (var dataIndex = 0; dataIndex < fData.values[field.id].length; dataIndex++) {
                                          var subData = fData.values[field.id][dataIndex];
                                          for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                              let subField = field.options.fieldList[subFieldIndex];
                                              if (subField.type === 'serialNumber' && subField.options.ext3 === '2' && !formData[dIndex].values.id && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                  await this.setSerialNumberOfForm(subField.options.config.options[0].value, subField, subData, formInfo);
                                              } else if (subField.type === 'serialNumber' && subField.options.ext3 === '4' && operateType === '2' && !subField.isRead && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                  await this.setSerialNumberOfForm(subField.options.config.options[0].value, subField, subData, formInfo);
                                              }
                                          }
                                      }
                                      // field.type === 'serialNumber' 审批流字段
                                      // field.options.ext3,'2'：保存后生成，4：审批后生成
                                      // operateType，1:完成（即保存），2：同意/通过（即审批通过）
                                      // field.isRead,true（disabled）：不可编辑，其他（false/null），可编辑
                                      // fData.values[field.formField],判断此字段是否已存在
                                  } else if (field.type === 'serialNumber' && field.options.ext3 === '2' && !formData[dIndex].values.id && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                      await this.setSerialNumberOfForm(field.options.config.options[0].value, field, fData.values, formInfo);
                                  } else if (field.type === 'serialNumber' && field.options.ext3 === '4' && operateType === '2' && !field.isRead && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                      await this.setSerialNumberOfForm(field.options.config.options[0].value, field, fData.values, formInfo);
                                  } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                      let ext2Obj = JSON.parse(field.options.ext2);
                                      let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                      if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                          for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                              if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                                  await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                              }
                                          }
                                      } else {
                                          if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                              await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                          }
                                      }
                                  } else if (field.type === 'serialNumber') { // 多规则的流水号生成规则
                                      let ext2 = field.options.ext2;
                                      if (ext2) {
                                          let ext2Obj = JSON.parse(ext2);
                                          if (ext2Obj.moreSerialNumber) { // 多规则配置
                                              let seriaNumberAutoincrementType = null;
                                              let serialNumberRuleList = ext2Obj.serialNumberRuleList;
                                              for (let i = 0; i < serialNumberRuleList.length; i++) {
                                                  let element = serialNumberRuleList[i];
                                                  let takeEffectField = element.takeEffectField;
                                                  let takeEffectFieldValue = element.takeEffectFieldValue;
                                                  let formFieldVal = formData.values[takeEffectField];
                                                  if (element.seriaNumberAutoincrementType) { // 说明配置了自增体 1部门自增体 流水号自增体
                                                      seriaNumberAutoincrementType = element.seriaNumberAutoincrementType;
                                                  }
                                                  if (takeEffectFieldValue.indexOf(formFieldVal) !== -1) { // 满足条件了
                                                      if (element.seriaNumberDepartTypeFormFieldId) {
                                                          ext2Obj.seriaNumberDepartTypeFormFieldId = element.seriaNumberDepartTypeFormFieldId;
                                                      }
                                                      if (element.seriaNumberDepartTypeFormFieldIdValue) {
                                                          ext2Obj.seriaNumberDepartTypeFormFieldIdValue = element.seriaNumberDepartTypeFormFieldIdValue;
                                                      }
                                                      if (element.seriaNumberSelectTypeFormFieldId) {
                                                          ext2Obj.seriaNumberSelectTypeFormFieldId = element.seriaNumberSelectTypeFormFieldId;
                                                      }
                                                      field.options.ext2 = JSON.stringify(ext2Obj);
                                                      await this.setSerialNumber(element.selectedNode.id, field, fData.values, formInfo, seriaNumberAutoincrementType);
                                                      break;
                                                  }
                                              }
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          },
          async setSerialNumberOfForm (sid, field, formData, formInfo, seriaNumberAutoincrementType) {
              // if (sid) {
              //     let numberObj = await getSerialNumber(sid);
              //     if (numberObj) {
              //         formData[field.formField] = numberObj.newSerialNumber;
              //         formData[field.formField + '-sn'] = numberObj.sn;
              //     }
              // }
              if (sid) {
                  let busiId = null;
                  let departId = null;
                  let configOptionId = null;
                  let upSerialNumber = null; // 国融合同表单框架合同号
                  for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                      let tempField = formInfo.fieldsList[fieldIndex];
                      if (tempField.type === 'businessTree') {
                          busiId = formData[tempField.formField];
                      } else if (tempField.type === 'department') {
                          departId = formData[tempField.formField];
                      } else if (tempField.type === 'select') {
                          // 中泽的项目立项表的业务分类选项字段
                          if (tempField.id === '1d3bb7fd093943709bfbd36fd6c15ca4') {
                              let optionValue = formData[tempField.formField];
                              let configOptions = tempField.options.config.options;
                              for (let k = 0; k < configOptions.length; k++) {
                                  let item = configOptions[k];
                                  if (item.value === optionValue) {
                                      configOptionId = item.id;
                                      break;
                                  }
                              }
                          }
                      } else if (tempField.type === 'link') {
                          if (formInfo.id === 'b81cbd9fa972415ebb00d3e40e1f5522') { // 国融【合同信息表】
                              if (tempField.id === '7abddcef62424e4b99145cfa7080e42c') { // 合同表单的【关联框架合同】字段
                                  let linkObj = formData[tempField.formField];
                                  // console.log(linkObj);
                                  if (linkObj) {
                                      let linkObjTableData = linkObj['tableData'][0];
                                      if (linkObjTableData) {
                                          // 合同编号 c6219b4ce1e94150b0f0a00ab63ecf83
                                          upSerialNumber = linkObjTableData['c6219b4ce1e94150b0f0a00ab63ecf83'];
                                          // console.log(upSerialNumber);
                                      }
                                  }
                              }
                          }
                      };
                  }
                  let numberObj = null;
                  let departmentId = null;
                  if (field.options.ext2) {
                      let ext2Obj = JSON.parse(field.options.ext2);
                      if (ext2Obj.seriaNumberFormFieldId) { // 部门占位符取值
                          departmentId = formData[ext2Obj.seriaNumberFormFieldId];
                          if (departmentId) {
                              departmentId = Number(departmentId);
                              let param = {id: sid, busiId: busiId, departId: departId, departmentId: departmentId};
                              if (seriaNumberAutoincrementType) {
                                  param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                              }
                              numberObj = await getSerialNumberDepartment(param);
                          } else {
                              this.$message.error('流水号关联的部门未选取,数据无法生成流水号');
                              return;
                          }
                      } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId && ext2Obj.seriaNumberDepartTypeFormFieldId) { // 业务分类和部门都选择的
                          let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                          let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                          let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId) { // 业务分类
                          let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                          let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else if (ext2Obj.seriaNumberDepartTypeFormFieldId) { // 部门
                          let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                          let param = {id: sid, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                          let param = {id: sid};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else {
                          if (busiId && departId) {
                              numberObj = await getSerialNumber(sid, busiId, departId);
                          } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                              numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                          } else {
                              numberObj = await getSerialNumber(sid);
                          }
                      }
                  } else {
                      if (busiId && departId) {
                          numberObj = await getSerialNumber(sid, busiId, departId);
                      } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                          numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                      } else {
                          numberObj = await getSerialNumber(sid);
                      }
                  }
                  // let numberObj = await getSerialNumber(sid);
                  if (numberObj) {
                      formData[field.formField] = numberObj.newSerialNumber;
                      formData[field.formField + '-sn'] = numberObj.sn;
                      if (upSerialNumber) {
                          formData[field.formField] = upSerialNumber + '-' + numberObj.newSerialNumber;
                      }
                      // console.log(formData[field.formField]);
                  }
              }
          },
          jumpToPage () {
              if (this.fromWorkAssistant || this.isNewModePage) { // 1、从工作助手过来的页面，发起流程跳到我发起的页面 2、新版本页面，菜单点击发起流程
                  // console.log(this.fromWorkAssistant);
                  // 流程实例ID，流程实例名称，流程实例状态
                  if (this.startedProcessInstance) { // 发起成功
                      let processInstanceStr = {};
                      processInstanceStr.processInstanceId = this.startedProcessInstance.id;
                      processInstanceStr.processInstanceName = this.startedProcessInstance.name;
                      processInstanceStr.finish = false;
                      let processInstanceJson = JSON.stringify(processInstanceStr);
                      sessionStorage.setItem('navToProcessList', processInstanceJson);
                  }
                  this.navMyProcessmyProcessStartedBy();
              } else {
                  if (this.isReturnToNav) {
                      // console.log('processInstancePop');
                      if (this.startedProcessInstance) { // 发起成功
                          // 流程实例ID，流程实例名称，流程实例状态
                          let processInstanceStr = {};
                          processInstanceStr.processInstanceId = this.startedProcessInstance.id;
                          processInstanceStr.processInstanceName = this.startedProcessInstance.name;
                          processInstanceStr.finish = false;
                          let processInstanceJson = JSON.stringify(processInstanceStr);
                          sessionStorage.setItem('navToProcessList', processInstanceJson);
                      }
                      this.$emit('navToBusiniessProcessTab');
                  } else {
                      if (this.taskInfo) {
                          // this.navMyProcess();
                          this.$emit('refreshSubProcess');
                      } else {
                          this.$emit('handleClosePop');
                          if (this.canViewProcessDetail) {
                              this.navMyProcess();
                          }
                          // else{
                          //    this.messageTip('您无流程权限，无法查看流程详情！', 'warning');
                          //    return false;
                          // }
                      }
                  }
              }
          },
          handleShowCommonUseConfigSelect () {
              this.loadTimer = new Date().getTime();
              this.isShowCommonUseConfigDialog = true;
          },
          commonUseConfigSelectTrigger (selected) {
              // console.log(selected);
              if (!isEmpty(selected.taskConfigInfo)) {
                  this.selectedHisProcessTaskList = JSON.parse(selected.taskConfigInfo);
              }
          },
          async commonUseConfigSelectConfirm () {
              this.countersignList = [];
              if (this.selectedHisProcessTaskList && this.selectedHisProcessTaskList.length > 0) {
                  this.taskList.forEach(item => {
                      let hisTaskInfo = {};
                      for (let i = 0; i < this.selectedHisProcessTaskList.length; i++) {
                          if (this.selectedHisProcessTaskList[i].taskId === item.taskId) {
                              hisTaskInfo = this.selectedHisProcessTaskList[i];
                              break;
                          }
                      }
                      if (hisTaskInfo && hisTaskInfo.executor) {
                          if (item.executor.modeType === hisTaskInfo.executor.modeType) {
                              if (item.executor.modeType === 0) {
                                  item.executor.assigneeUsers = hisTaskInfo.executor.assigneeUsers;
                                  item.executor.assigneeUsersName = hisTaskInfo.executor.assigneeUsersName;
                              } else if (item.executor.modeType === 2) { // 会签
                                  let executorsTemp = [];
                                  let userIdArray = hisTaskInfo.executor.countersignUsers.split(',');
                                  let userNameArray = hisTaskInfo.executor.countersignUsersName.split(',');
                                  for (let j = 0; j < userIdArray.length; j++) {
                                      executorsTemp.push({
                                          userId: userIdArray[j],
                                          trueName: userNameArray[j],
                                          executionOrder: j
                                      });
                                  }
                                  hisTaskInfo.executor.executors = executorsTemp;
                                  hisTaskInfo.executor.taskId = hisTaskInfo.taskId;
                                  let executorTemp = cloneDeep(hisTaskInfo.executor);
                                  item.executor = executorTemp;
                                  // console.log(executorTemp);
                                  this.countersignList.push(executorTemp);
                              }
                          }
                      }
                  });
              }
              // console.log(this.countersignList);
              this.taskLoadTimer = new Date().getTime();
              this.isShowCommonUseConfigDialog = false;
          },
          handleClose () {
              this.messageTip('流程已经发起成功，请稍后在【我的流程】中查看', 'info');
              this.$emit('handleClosePop');
          },
          messageTip (msg, type) {
              this.$message({
                  message: msg,
                  type: type,
                  duration: 3000
              });
          }
      }
  };
</script>


<style lang="less">
  .process-template-list {
      width: 100%;
      margin-top: -25px;
      height: ~"calc(100% - 60px)";
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;

      .resetProcessInstance {
          padding: 7px 15px;
          vertical-align: middle;
          margin-left: 5px;
      }

      .process-item {
          height: 200px;
          width: 23%;
          // min-width: 15%;
          margin: 5px;
          border: 1px solid #e8edf1;

          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .el-card__body {
              flex: 1;
              display: flex;
              flex-direction: column;
          }
      }

      .process-item:hover {
          border: 1px solid #6db2bb;
      }

      .process-img {
          flex: 1;
          cursor: pointer;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
      }

      .process-bottom {
          font-size: 12px;
          background-color: #e8edf1;
          padding: 5px;

          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
      }
      .process-top {
          font-size: 12px;
          // background-color: #e8edf1;
          padding: 2px;

          // display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
      }
      .batchBtn {
          float: right;
      }
  }
    .choosedProcessClass{
      background-color: #b5fb92;
    }
    .choosedClass:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }

.template-list-pop {
      width: 100%;
      height:420px;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;

      .process-item {
          height: 200px;
          width: 23%;
          // min-width: 15%;
          margin: 5px;
          border: 1px solid #e8edf1;

          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .el-card__body {
              flex: 1;
              display: flex;
              flex-direction: column;
          }
      }

      .process-item:hover {
          border: 1px solid #6db2bb;
      }

      .process-img {
          flex: 1;
          cursor: pointer;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
      }

      .process-bottom {
          font-size: 12px;
          background-color: #e8edf1;
          padding: 5px;

          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
      }
      .process-top {
          font-size: 12px;
          // background-color: #e8edf1;
          padding: 2px;

          // display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
      }
  }

.tools-bar-pop{
    margin-top: -20px;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessTemplate/ProcessInstancePop.vue